/* eslint-disable no-unused-vars */

import React, { useMemo, useRef } from 'react';
import style from './style.module.scss';
import SiteCard from '@components/site-card';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { useDispatch } from 'react-redux';
import { siteMapActions } from '@redux/slices/site-map';

const SiteCardMenuBottom = ({
  selectedSiteIdForMapView,
  siteChildrenList,
  openMapMenu = false,
  picklistsMap,
  tab
}) => {
  const siteCardBottomDivRefs = useRef([]);
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  const bottomSiteCardHeightWithIndexes = useMemo(() => {
    let hightMapOfSiteCard = {};
    if (openMapMenu && siteCardBottomDivRefs?.current) {
      siteCardBottomDivRefs?.current.forEach((ref, index) => {
        if (ref) {
          let smallScreenWidth = width <= 767 ? 80 : 0;
          hightMapOfSiteCard = {
            ...hightMapOfSiteCard,
            [index]: (ref.offsetHeight || 0) + smallScreenWidth || 0
          };
        }
      });
    }
    dispatch(siteMapActions.setBottomSiteCardHeightWithIndexes(hightMapOfSiteCard));
    return hightMapOfSiteCard;
  }, [tab, siteCardBottomDivRefs?.current, openMapMenu, selectedSiteIdForMapView?.siteId, width]);

  let list = useMemo(() => {
    let siteList =
      siteChildrenList?.length > 0
        ? selectedSiteIdForMapView?.siteId
          ? [
              ...siteChildrenList.filter((x) => x?.siteId === selectedSiteIdForMapView?.siteId),
              ...siteChildrenList.filter((x) => x?.siteId !== selectedSiteIdForMapView?.siteId)
            ]
          : siteChildrenList
        : [];

    return siteList;
  }, [siteChildrenList, selectedSiteIdForMapView?.siteId]);

  return (
    <div
      id="site-card-container-bottom"
      className={`${style.siteCardContainerOnSmallAndTabletScreenOnMapView} ${
        selectedSiteIdForMapView?.siteId &&
        style.siteCardContainerOnSmallAndTabletScreenOnMapViewShowCard
      } `}
      style={{
        top: `calc(100svh - ${
          selectedSiteIdForMapView?.siteId
            ? bottomSiteCardHeightWithIndexes[
                siteChildrenList.findIndex((x) => x?.siteId === selectedSiteIdForMapView?.siteId)
              ]
            : 0
        }px)`
      }}
    >
      {list?.map((listItem, index) => {
        return (
          <div
            key={index}
            ref={(el) => (siteCardBottomDivRefs.current[index] = el)}
            id={`site-card-container-bottom-${index}`}
          >
            <SiteCard
              distance={listItem.distance}
              unit={listItem.unit}
              siteDetailsCard
              mapSiteCard
              chips={false}
              title={listItem?.area}
              subtitle={listItem?.name}
              dataPoints={listItem?.dataPoints || []}
              allTasksForSite={listItem?.tasks}
              allDoneTasks={listItem?.allDoneTasks}
              isOverDue={listItem?.isOverDue}
              status={picklistsMap[listItem?.status]?.value}
              moreInfo={false}
              equipmentCount={listItem?.equipmentCount}
              siteId={listItem?.siteId}
              to={`/site-details/${listItem?.siteId}`}
            />

            <div style={{ width: '100%', borderTop: '.5px solid rgb(203, 210, 217)' }} />
          </div>
        );
      })}
    </div>
  );
};

export default SiteCardMenuBottom;
